import React from "react";
import {
  StepIconProps,
  Box,
  styled,
  ButtonBase,
} from "@mui/material";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

interface StepItem {
  label: string;
  isActive: boolean;
  isCompleted: boolean;
}

interface CustomStepperProps {
  steps: StepItem[];
  currentStep: number;
  handleChangeStep: Function;
}

const StepCircle = styled(Box)<{
  ownerState: { isActive: boolean; isCompleted: boolean };
}>(({ theme, ownerState }) => ({
  width: "30px",
  height: "30px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "12px",
  fontWeight: 600,
  transition: "all 0.2s ease",
  ...(ownerState.isCompleted || ownerState.isActive
    ? {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        border: "none",
      }
    : {
        backgroundColor: "transparent",
        color: theme.palette.text.disabled,
        border: `2px solid ${theme.palette.neutral[200]}`,
      }),
}));

function CustomStepIcon(
  props: StepIconProps & { isActive: boolean; isCompleted: boolean }
) {
  const { isActive, isCompleted, icon } = props;
  return (
    <StepCircle ownerState={{ isActive, isCompleted }}>
      {icon}
    </StepCircle>
  );
}

const CustomMobileStepper: React.FC<CustomStepperProps> = ({
  steps,
  currentStep,
  handleChangeStep,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        boxSizing: "border-box",
        backgroundColor: "common.white",
        maxWidth: "320px",
        // padding: "16px 24px",
      }}
    >
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          {/* Circle — fixed, never grows */}
          <ButtonBase
            onClick={() => handleChangeStep(index)}
            sx={{
              flexShrink: 0,
              width: "44px",
              height: "44px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CustomStepIcon
              icon={index + 1}
              isActive={step.isActive}
              isCompleted={step.isCompleted}
            />
          </ButtonBase>

          {index < steps.length - 1 && (
            <Box
              sx={{
                flex: 1,
                height: "2px",
                backgroundColor: step.isCompleted
                  ? "primary.main"
                  : "neutral.200",
                transition: "backgroundColor 0.2s ease",
              }}
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default CustomMobileStepper;